
export let focusableElements = [];
export let firstFocusableElement, lastFocusableElement;

export let prevFocusedElement;

export const getFocusableElements = (modal) => {
  return Array.from(
    modal.querySelectorAll('input:not([type="hidden"]), button, a, [tabindex]:not([tabindex="-1"])')
  ).filter(el => !el.disabled);
}

export const setupFocusTrap = (currModal, prevFcsdEl) => {
  if (prevFcsdEl) prevFocusedElement = prevFcsdEl;
  focusableElements = getFocusableElements(currModal);
  firstFocusableElement = focusableElements[1] || focusableElements[focusableElements.length - 1];
  lastFocusableElement = focusableElements[focusableElements.length - 1];
  firstFocusableElement.focus();
}

export const handleTab = (event, currModal) => {
  focusableElements = getFocusableElements(currModal);
  const firstFocusableElement = focusableElements[0];
  const lastFocusableElement = focusableElements[focusableElements.length - 1];
  if (event.key === 'Tab') {
    if (event.shiftKey) {
      if (document.activeElement === firstFocusableElement) {
        event.preventDefault();
        lastFocusableElement.focus();
      }
    } else {
      if (document.activeElement === lastFocusableElement) {
        event.preventDefault();
        firstFocusableElement.focus();
      }
    }
  }
}

export const debounce = (func, wait) => {
  let timeout;
  return function (...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
}

export const renderError = (container, message) => {
  container.innerHTML = `
    <div class="calculator__form-result-desc-item">
        <div class="calculator__form-result-txt-container">
            <p class="calculator__form-result-txt" style="color: #dc3545;">Ошибка: ${message}</p>
        </div>
    </div>
  `;
}

export const getCookie = (name) => {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.substring(0, name.length + 1) === (name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

export const Fetch = (url, options) => {
  const csrfToken = getCookie('csrftoken');
  const headers = {
    'X-CSRFToken': csrfToken,
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  };
  return fetch(url, {
    ...options,
    headers: {
      ...headers,
      ...options?.headers,
    }
  });
}

export const displayError = (message, container) => {
  if (!container) {
    alert('Ошибка: ' + message);
    return;
  }
  renderError(container, message);
} 
